<template lang="html">
  <section class="popup-mask" v-if="active">
    <div class="container-popup">
      <button class="close" @click="active = false">
        <img src="/static/img/icon-close-white.svg" alt="cerrar" />
      </button>
      <img src="/static/img/newsletter/pc.png" alt="pc" class="decor1" />
      <p class="title">
        {{ $t("newsletter.popup.title") }}
      </p>
      <button @click="goto()" class="btn -action">
        {{ $t("newsletter.popup.cta") }}
      </button>
      <img
        src="/static/img/newsletter/palomita-avion.png"
        alt="palomita y avión"
        class="decor2"
      />
    </div>
  </section>
</template>

<script lang="js">
export default  {
  name: 'popup-newsletter',
    data() {
        return {
            active:true,
        }
    },
    methods:{
        goto: function (value) {
            $("html, body").animate({ scrollTop: $("#newsletter").offset().top }, 1000),
            this.active = false
        }
    }
}
</script>
<style scoped lang="scss">
.popup-mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background: #0000006e;
  animation: fadeIn 3s;
  .container-popup {
    max-width: 390px;
    background: #ac1830;
    position: relative;
    padding: 124px 20px 90px 20px;
    .title {
      font-family: "Futura LT CondensedExtraBold";
      color: white;
      font-size: 32px;
      line-height: 1.2em;
      text-align: center;
      margin-bottom: 40px;
    }
    .close {
      background: transparent;
      border: 0;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      img {
        width: 15px;
      }
    }
    .decor1 {
      position: absolute;
      top: -98px;
      right: 0;
      left: 0;
      margin: 0 auto;
      max-width: 240px;
    }
    .decor2 {
      position: absolute;
      bottom: -50px;
      right: -25px;
      max-width: 446px;
      margin: 0 auto;
    }
  }
}
@media screen and(max-width: 700px) {
  .popup-mask {
    padding: 20px;
  }
  .popup-mask .container-popup .decor2 {
    max-width: 100%;
    left: 0;
    right: 0;
  }
  .popup-mask .container-popup .title {
    font-size: 25px;
  }
  .popup-mask .btn.-action {
    right: 0;
    font-size: 25px;
  }
  .popup-mask .container-popup {
    padding: 124px 20px 30px 20px;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/popup-newsletter.vue